<script setup lang="ts">
import BaseButton from '@/components/base/BaseButton.vue'
import { computed } from 'vue'
import { T } from '@tolgee/vue'
import { useWatchOverlays } from '@/composables/helpers/scoll'

const props = defineProps<{
  show: boolean
}>()

useWatchOverlays(computed(() => props.show))

</script>

<template>
  <div
    class="fixed h-screen max-h-dvh w-screen overflow-hidden left-0 bottom-0 transition-all duration-300 bg-dark-primary bg-outer flex flex-col"
  >
    <div class="h-full w-full bg-dark-most-bottom-layer/[.95] flex-1 flex flex-col">
      <div class="p-8 h-[90%] w-full mt-auto flex flex-col items-center justify-between">
        <div class="w-full items-center flex flex-col gap-y-6 flex-1">
          <div class="w-[240px] min-w-[240px] h-[240px] relative">
            <div class="absolute inset-0 rounded-full bg-teal-primary/[.74] blur-[43px]" />
            <img
              class="w-[240px] min-w-[240px] h-[240px] rounded-full object-cover bg-black/[.12] shadow-image backdrop-blur-sm absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2"
              src="@/assets/images/check-circle-transparent.png"
            >
          </div>
          <div class="mt-4 text-lg leading-6 text-center font-semibold max-w-[379px]">
            <T
              key-name="cipher.message"
              default-value="Congratulations! You've successfully silenced the Fudders and strengthened your project's reputation!"
            />
          </div>
          <BaseButton
            class="w-full mt-auto"
          >
            <T
              key-name="cipher.claim"
              default-value="Claim prize"
            />
          </BaseButton>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.bg-outer {
  background: url('@/assets/images/code.png') lightgray 50% / cover no-repeat;
}

.shadow-image {
  box-shadow: 0px 4px 4px 0px rgba(255, 255, 255, 0.40) inset;
}

@keyframes glow {
  0% {
    box-shadow: 0 0 20px rgba(255, 105, 180, 0.5), 0 0 40px rgba(255, 105, 180, 0.4), 0 0 60px rgba(255, 105, 180, 0.3);
    transform: translate(0, 0) rotate(0deg);
  }
  50% {
    box-shadow: 0 0 40px rgba(255, 105, 180, 0.7), 0 0 80px rgba(255, 105, 180, 0.6), 0 0 120px rgba(255, 105, 180, 0.5);
  }
  100% {
    box-shadow: 0 0 20px rgba(255, 105, 180, 0.5), 0 0 40px rgba(255, 105, 180, 0.4), 0 0 60px rgba(255, 105, 180, 0.3);
    transform: translate(0, 0) rotate(360deg);
  }
}

.animate-glow {
  animation: glow 2s infinite alternate;
}
</style>
